function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-1-1h26v26H-1z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.09 21.983H.91c-.466 0-.831.382-.831.825s.385.825.83.825H23.11c.467 0 .832-.382.832-.825s-.386-.825-.852-.825zM.079 14.677l-.02 3.925c0 .221.08.442.243.603a.815.815 0 00.588.242l3.933-.02c.223 0 .426-.08.588-.242L18.995 5.7a.846.846 0 000-1.187L15.102.608a.861.861 0 00-1.196 0l-2.717 2.717L.322 14.093a.893.893 0 00-.243.584zM14.514 2.379l2.737 2.717-1.54 1.53-2.738-2.717 1.541-1.53zM1.761 15.04l10.016-9.943 2.737 2.718-10.016 9.922-2.757.02.02-2.717z"
})));

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4c4e4852.svg";
export { ForwardRef as ReactComponent };